import { api } from "@/api/client";

export type Incident = {
  id: string;
  tenant_id: string;
  title: string;
  description: string;
  severity: string;
  occurred_at: string;
  site_id: string | null;
  asset_id: string | null;
  status: string;
  reported_by: string | null;
  owner_id: string | null;
  review_status: string;
  review_notes: string | null;
  review_submitted_at: string | null;
  reviewed_at: string | null;
  reviewed_by: string | null;
  approved_at: string | null;
  approved_by: string | null;
  created_at: string;
  updated_at: string;
};

export type IncidentCreate = {
  title: string;
  description?: string;
  severity: string;
  occurred_at: string;
  site_id?: string | null;
  asset_id?: string | null;
  status?: string;
  owner_id?: string | null;
};

export type IncidentUpdate = Partial<IncidentCreate>;

export type IncidentReviewAction = "submit" | "approve" | "reject";

export type IncidentLink = {
  id: string;
  incident_id: string;
  assessment_id: string | null;
  threat_id: string | null;
  note: string;
  created_at: string;
};

export async function listIncidents(): Promise<Incident[]> {
  return api.get("incidents").json<Incident[]>();
}

export async function createIncident(payload: IncidentCreate): Promise<Incident> {
  return api.post("incidents", { json: payload }).json<Incident>();
}

export async function updateIncident(
  id: string,
  payload: IncidentUpdate,
): Promise<Incident> {
  return api.patch(`incidents/${id}`, { json: payload }).json<Incident>();
}

export async function deleteIncident(id: string): Promise<void> {
  await api.delete(`incidents/${id}`);
}

export async function reviewIncident(
  id: string,
  action: IncidentReviewAction,
  reviewNotes?: string,
): Promise<Incident> {
  return api
    .post(`incidents/${id}/review`, {
      json: { action, review_notes: reviewNotes },
    })
    .json<Incident>();
}

export async function listIncidentLinks(id: string): Promise<IncidentLink[]> {
  return api.get(`incidents/${id}/links`).json<IncidentLink[]>();
}
